module.exports = __webpack_public_path__ + "static/derby-363a813954b03e35891db8ccd4c29d3b.png";